export interface SurchargesMaintenance {
  surchargeId?: number;
  code: number;
  name: string;
}

export interface SurchargesMaintenanceDetails
  extends Pick<SurchargesMaintenance, 'surchargeId'> {
  valid: Valid;
  description?: string;
  method: string;
  flags: ('REQUEST_BASED_SERVICE_FLAG' | 'SERVICE_BR_DEFAULT_FLAG')[];
  serviceBrId?: number;
  surcharge1Duty?: number;
  surcharge1Nom?: number;
  surcharge1Perc?: number;
  surcharge3Duty?: number;
  surcharge3Nom?: number;
  surcharge3Perc?: number;
  vatSvc?: string;
  surchargeDynId: number;
}

interface Valid {
  from: Date | null;
  to: Date | null;
}

export enum SurchargesMaintenanceFlag {
  REQUEST_BASED_SERVICE_FLAG = 'REQUEST_BASED_SERVICE_FLAG',
  SERVICE_BR_DEFAULT_FLAG = 'SERVICE_BR_DEFAULT_FLAG'
}

export interface VatOption {
  code: string;
  groupId: number;
  name: string;
  id: number;
}

export interface ServiceBrOption {
  code: string;
  name: string;
  pool: {
    name: string;
    id: number;
  };
  privilegedEmailAddress: string;
  id: number;
  validity: {
    start: Date;
    end: Date;
  };
  type: string;
  dynId: number;
  nameShort: string;
  remarks: string;
}

export interface DetailsData
  extends SurchargesMaintenanceDetails,
    SurchargesMaintenance {}

export interface DetailsDataForSave extends SurchargesMaintenance {
  details: SurchargesMaintenanceDetails[];
}
